import { CheckIcon } from "@phosphor-icons/react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslations } from "use-intl";

import { validateOrderId } from "@/app/routeValidation";
import { Button } from "@/components/Button/Button";
import { PersistentDrawer } from "@/components/Drawer/PersistentDrawer";
import { OverviewCard } from "@/features/trips/components/bookingFlow/success/OverviewCard";
import { tripQueryOptions } from "@/features/trips/hooks/useTrips";
import { useOrder } from "@/hooks/useOrder";

export const Route = createFileRoute("/_authenticated/trips/$tripId/success")({
  validateSearch: validateOrderId,
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();
  const { orderId } = Route.useSearch();
  const { tripId } = Route.useParams();
  const navigate = Route.useNavigate();
  const { data: trip } = useSuspenseQuery(tripQueryOptions(tripId));
  const { data: orderData } = useOrder(orderId);

  const tripBooking = orderData?.packageBookings?.[0];

  return (
    <>
      <div className="space-y-3">
        <div className="flex gap-2 rounded-3xl bg-white p-3">
          <CheckIcon
            weight="bold"
            color="var(--color-surface-accent-stronger)"
            size={24}
            className="shrink-0 rounded-full bg-surface-accent-medium p-1"
          />

          <div>
            <div className="mb-1 text-base font-medium text-text-primary">
              {t("trips.successPage.title")}
            </div>
            <div className="text-sm text-text-tertiary">
              {t("trips.successPage.subtitle")}
            </div>
          </div>
        </div>

        <OverviewCard trip={trip} startDate={tripBooking?.startDate} />
      </div>

      <PersistentDrawer>
        <div className="mb-2">
          <Button
            onClick={() => {
              navigate({ to: "/" });
            }}
            variant="contained"
            fullWidth
          >
            {t("backToHome")}
          </Button>
        </div>
        <Button
          onClick={() => {
            navigate({ to: "/bookings", search: { category: "trips" } });
          }}
          variant="text"
          fullWidth
        >
          {t("openMyBookings")}
        </Button>
      </PersistentDrawer>
    </>
  );
}
